import { render, staticRenderFns } from "./LegoControlCardValidate.vue?vue&type=template&id=326fedd9"
import script from "./LegoControlCardValidate.vue?vue&type=script&lang=js"
export * from "./LegoControlCardValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports